import React from "react";
import MaterialityAssessment from "../components/MaterialityAssessment";

function MaterialityAssessmentContainer() {
  return <MaterialityAssessment />;
}

export default MaterialityAssessmentContainer;
